import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/** @jsxRuntime automatic */
/** @jsxImportSource react */
import { useId } from 'react';
/** Explains the one blocking reason the person can act on first. */
export function continueCardHint(blocked, kind = 'local-file') {
    if (blocked.worldMode)
        return 'Choose Work IQ to continue.';
    if (blocked.draft || blocked.attachments)
        return 'Send or clear your draft first.';
    if (blocked.dictating)
        return 'Finish dictating first.';
    if (blocked.busy)
        return 'Wait for the current answer to finish.';
    return kind === 'mcp'
        ? 'Use this completed result for the next step. Further calls still need your approval.'
        : 'Use this completed result for the next step. New file actions still need review.';
}
/** The button's label: a file task is continued by name; any other call's result is simply taken up. */
export function continueCardLabel(kind) {
    return kind === 'mcp' ? 'Continue with this result' : 'Continue file task';
}
/** The explicit "Continue file task" step after a verified, acknowledged local file action. Nothing is sent until the
 * person clicks, and the result is sent as fenced evidence beside a short visible message, never as their own words.
 * The hint describes the button, so a screen reader that reaches it hears why it is disabled or what it will do.
 * For any other MCP server's result the chat continues on its own when it can (GyroAssistant); this card shows only
 * while something holds that up (a draft, dictation, World IQ, a running answer), so the person can continue by hand. */
export function LocalFileContinueCard({ result, blocked, onContinue }) {
    const disabled = blocked.busy || blocked.worldMode || blocked.dictating || blocked.draft || blocked.attachments;
    const hintId = useId();
    return _jsxs("div", { className: "gyro-local-file-continue", "data-tool": result.tool, "data-kind": result.kind, children: [_jsx("button", { type: "button", className: "gyro-btn ghost", disabled: disabled, "aria-describedby": hintId, onClick: () => { if (!disabled)
                    onContinue(result); }, children: continueCardLabel(result.kind) }), _jsx("small", { id: hintId, children: continueCardHint(blocked, result.kind) })] });
}
//# sourceMappingURL=LocalFileContinueCard.js.map